import type { WebsiteBlock } from '../../types'
import { useBranding } from '../../contexts/BrandingContext'
import { useI18n } from '../../i18n'
import { Mail, Phone, MapPin } from 'lucide-react'

interface ContactProps {
  title: string
  titleEn?: string
  email?: string
  phone?: string
  address?: string
  addressEn?: string
  showForm: boolean
  showMap: boolean
}

export default function ContactBlock({ block }: { block: WebsiteBlock }) {
  const { branding } = useBranding()
  const { lang } = useI18n()
  const p = block.props as ContactProps

  const title = lang === 'en' && p.titleEn ? p.titleEn : p.title
  const hasContent = title?.trim() || p.phone?.trim() || p.email?.trim() || p.address?.trim() || p.showForm
  if (!hasContent) return null

  return (
    <section className="py-20 px-6 bg-gray-50/50">
      <div className="max-w-4xl mx-auto">
        {title?.trim() && (
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-12 tracking-tight" style={{ color: branding.secondaryColor }}>
            {title}
          </h2>
        )}
        <div className="grid md:grid-cols-2 gap-8">
          <div className="space-y-4">
            {p.email && (
              <div className="flex items-center gap-3">
                <div className="h-10 w-10 rounded-xl flex items-center justify-center" style={{ backgroundColor: `${branding.primaryColor}12` }}>
                  <Mail className="h-4 w-4" style={{ color: branding.primaryColor }} />
                </div>
                <span className="text-sm text-gray-600">{p.email}</span>
              </div>
            )}
            {p.phone && (
              <div className="flex items-center gap-3">
                <div className="h-10 w-10 rounded-xl flex items-center justify-center" style={{ backgroundColor: `${branding.primaryColor}12` }}>
                  <Phone className="h-4 w-4" style={{ color: branding.primaryColor }} />
                </div>
                <span className="text-sm text-gray-600">{p.phone}</span>
              </div>
            )}
            {p.address && (
              <div className="flex items-start gap-3">
                <div className="h-10 w-10 rounded-xl flex items-center justify-center shrink-0" style={{ backgroundColor: `${branding.primaryColor}12` }}>
                  <MapPin className="h-4 w-4" style={{ color: branding.primaryColor }} />
                </div>
                <span className="text-sm text-gray-600">
                  {lang === 'en' && p.addressEn ? p.addressEn : p.address}
                </span>
              </div>
            )}
          </div>
          {p.showForm && (
            <div className="space-y-3">
              <input placeholder={lang === 'zh' ? '姓名' : 'Name'} className="w-full px-4 py-3 rounded-xl border border-black/[0.06] text-sm bg-white" />
              <input placeholder={lang === 'zh' ? '邮箱' : 'Email'} className="w-full px-4 py-3 rounded-xl border border-black/[0.06] text-sm bg-white" />
              <textarea placeholder={lang === 'zh' ? '留言' : 'Message'} rows={4} className="w-full px-4 py-3 rounded-xl border border-black/[0.06] text-sm bg-white resize-none" />
              <button className="px-6 py-2.5 rounded-xl text-white text-sm font-medium"
                style={{ backgroundColor: branding.primaryColor }}>
                {lang === 'zh' ? '发送' : 'Send'}
              </button>
            </div>
          )}
        </div>
      </div>
    </section>
  )
}
